import ar from './ar.json';
import en from './en.json';

/**
 * The Payments module's catalogue, registered from `app.config.tsx` under the
 * `payments` namespace — `shared/i18n` never imports a module (W2).
 *
 * The Arabic plurals carry all six CLDR categories where a count is
 * interpolated; English carries the two it has. The parity check compares plural
 * FAMILIES, so a missing dual is a failure rather than a sentence reading
 * "2 أيام".
 */
export const paymentsCatalogs = { ar, en };
